// extracted by mini-css-extract-plugin
export default {"container":"producer_container__cEe5f","producercontainer":"producer_producercontainer__LEMMr","img":"producer_img__7G-gz","el1":"producer_el1__Hncqn","el2":"producer_el2__Vji5y"};